import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Scissors, Palette, Sparkles, Wind, Smile, Droplet } from 'lucide-react';
const services = [{
  icon: <Scissors strokeWidth={1} size={32} data-id="element-225" />,
  title: 'Стрижки',
  description: 'Чоловічі, жіночі, дитячі стрижки будь-якої складності.'
}, {
  icon: <Palette strokeWidth={1} size={32} data-id="element-226" />,
  title: 'Фарбування',
  description: 'Балаяж, шатуш, аіртач та класичне фарбування.'
}, {
  icon: <Sparkles strokeWidth={1} size={32} data-id="element-227" />,
  title: 'Хімічна та біозавивка',
  description: 'Створення ідеальних локонів з турботою про волосся.'
}, {
  icon: <Wind strokeWidth={1} size={32} data-id="element-228" />,
  title: 'Укладка волосся',
  description: 'Вечірні, весільні та повсякденні укладки.'
}, {
  icon: <Smile strokeWidth={1} size={32} data-id="element-229" />,
  title: 'Манікюр і педикюр',
  description: 'Комплексний догляд за вашими нігтями.'
}, {
  icon: <Droplet strokeWidth={1} size={32} data-id="element-230" />,
  title: 'Прокол вух',
  description: 'Безпечний та швидкий прокол для дорослих і дітей.'
}];
export function Services() {
  return <section id="services" className="py-24 bg-gray-50" data-id="element-231">
      <div className="container mx-auto px-6 md:px-12" data-id="element-232">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-233">
          <h2 className="font-heading text-4xl md:text-5xl text-dark mb-4" data-id="element-234">
            Послуги
          </h2>
          <div className="w-12 h-px bg-accent mx-auto mb-6" data-id="element-235"></div>
          <p className="text-gray-500 font-light" data-id="element-236">
            Оберіть послугу, яка підходить саме вам.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-237">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group flex flex-col p-8 bg-white border border-gray-200 hover:border-dark transition-colors duration-300" data-id="element-238">
              <div className="text-dark mb-6 opacity-70 group-hover:opacity-100 transition-opacity duration-300" data-id="element-239">
                {service.icon}
              </div>
              <h3 className="text-2xl font-heading tracking-wide text-dark mb-4" data-id="element-240">
                {service.title}
              </h3>
              <p className="text-gray-500 text-sm font-light leading-relaxed flex-grow" data-id="element-241">
                {service.description}
              </p>

              <a href="#contact" className="mt-8 block w-full py-3 border border-gray-300 text-center text-xs font-medium tracking-widest uppercase text-dark hover:bg-dark hover:text-white hover:border-dark transition-all duration-300" data-id="element-242">
                Записатися
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}